import { render, staticRenderFns } from "./InventoryConsumable.vue?vue&type=template&id=b54726ca"
import script from "./InventoryConsumable.vue?vue&type=script&lang=js"
export * from "./InventoryConsumable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports